import React from "react";
import { Form, Button, Row } from "react-bootstrap";
import { toast } from 'react-toastify';
import {
    StyledModal,
    StyledModalBody,
    StyledModalFooter,
} from "../../../Styling/styledModal/styledModals";
import { BfFormControl, BfFormLabel } from "../../../Styling/styledForm/styledBlueForm";
import axiosTokenInstance from "../../../Instances/axiosTokenInstance";
import { BfButtonBlue, BfButtonBlueSecondary } from "../../../Styling/styledForm/styledBlueForm";


export const LoginMfaModal = (props) => {

    const messages = props.messages
    const mfaCodeCap = props.mfaCodeCap
    const fieldValues = props.fieldValues
    const handleChange = props.handleChange
    const cancel = props.cancel
    const submit = props.submit

    const sendSms = () => {

        let formData = new FormData()
        formData.append('email', props.fieldValues.email); 


        axiosTokenInstance({
            method: 'POST',
            url: `/api/apisecurity/SendSMSCode`,
            data: formData
        }).then((result) => {
            console.log('token sendt...')
            console.log(result);
            toast.info('Kode er sendt på SMS');
        })
            .catch((err) => {
                console.log(err);
                //setIsLoading(false)
                //toast.error('Registrering av tofaktor pålogging feilet.')    
                toast.error('Sending av SMS feilet');                              
            })

    }

    const submitDisabled = () => {
        console.log(props.fieldValues['mfaCode'])
        return (props.fieldValues['mfaCode']?.length != 6)
    }

    return (
        <StyledModal centered show={true} size="m" onHide={cancel}>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    if (!submitDisabled()) submit();
                }}
            >

                <StyledModalBody style={{width: '650px'}}>
                    <h4>{messages.mfaModalHeader}</h4>
                    <p style={{ whiteSpace: "pre-line" }}>{messages.confirmMessage}</p>
                    <p style={{ whiteSpace: "pre-line" }}>{messages.confirmMessage2}</p>
                    <p style={{ whiteSpace: "pre-line" }}> Obs! Kode sendt på SMS vil nå komme fra <b>Kred SA</b></p>

                    <Form.Group>

                        <BfFormLabel>{mfaCodeCap}</BfFormLabel>

                        <BfFormControl
                            className="col-md2"
                            type="mfaCode"
                            placeholder=""
                            name="mfaCode"
                            value={fieldValues['mfaCode']}
                            onChange={(event) => handleChange(event)}
                        />

                    </Form.Group>
                </StyledModalBody>

                <StyledModalFooter style={{width: '650px'}}>
                    <BfButtonBlue
                        type="submit"
                        onClick={submit}
                        disabled={submitDisabled()}
                    >
                        {messages.mfaOk}
                    </BfButtonBlue>

                    <BfButtonBlue onClick={sendSms}>
                        {messages.mfaSendSMS}
                    </BfButtonBlue>

                    <BfButtonBlueSecondary textAsBorder blackBorder onClick={cancel}>
                        {messages.mfaCancel}
                    </BfButtonBlueSecondary>

                </StyledModalFooter>
            </form>
        </StyledModal>
    );
};
